import { Component, OnInit } from '@angular/core';
import { CoursewareService } from 'src/services/CoursewareService';
import { MemberUserData } from 'src/model/User/MemberUserData';
import { Error } from 'src/model/Error';
import { AlertService } from '../_alert';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { globals } from '../shared/globals';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  public canResetPassword: boolean = false;
  public hasSentResetPasswordRequest: boolean = false;
  public badToken: boolean = false;
  tokenID: string = null;

  constructor(private _router: Router, private route: ActivatedRoute, private coursewareService: CoursewareService, private alertService: AlertService) { }

  ngOnInit() {
    this.tokenID = this.route.snapshot.paramMap.get('tokenID');
    if (!this.tokenID) {
      this.tokenID = this.route.snapshot.queryParams.tokenID;
    }
    console.log("tokenid " + this.tokenID);


    this.alertService.clear();
    this.hasSentResetPasswordRequest = true;
    this.coursewareService.ResetPassword(this.tokenID).subscribe(data => {
      if (data != null && data == "SUCCESS") {
        this.canResetPassword = true;
      } else {
        this.badToken = true;
        let error = data as Error
        this.alertService.error(error.Message);
      }
    },
      error => this.alertService.error("Caught unexpected error when logging in " + error.Message));
  }

  public resetPassword(form: NgForm) {
    this.alertService.clear();
    if (form.value.password == null || form.value.password.length < 1 || form.value.password != form.value.confirmPassword) {
      this.alertService.error("Cannot change password - The passwords must not be empty and must match each other.")
      return;
    }
    this.coursewareService.ResetAndChangePassword(this.tokenID, form.value.password).subscribe(data => {
      if (data != null && data == "SUCCESS") {
        this.alertService.info("Your password has successfully been changed.  Please log in.");
        this._router.navigate(["/loginview"]);
      } else {
        let error = data as Error
        this.alertService.error(error.Message);
      }
    },
      error => this.alertService.error("Caught unexpected error when logging in " + error.Message));
  }
}
